import { put, takeEvery } from 'redux-saga/effects';
import analytics from '@xto10x/core/lib/analytics';

import userboardApi from 'services/userboardApi';
import { showAlertMessage } from 'containers/App/store/actions';
import { saveObjectives } from 'containers/Objective/store/actions';
import {
  actions,
  saveUserboardData,
  saveTeamUsersData,
  increaseLoadingCount,
  decreaseLoadingCount
} from './actions';

function* fetchUserboardDataWorker({ requestBody }) {
  try {
    yield put(increaseLoadingCount());
    const { data } = yield userboardApi.getUserboardData(requestBody);
    yield put(saveUserboardData(data.user_okr_infos));
    yield put(decreaseLoadingCount());
  } catch (e) {
    yield put(decreaseLoadingCount());
    yield put(showAlertMessage('error', e.message));
    analytics.trackError('fetch userboard teams, department and users data', e);
  }
}

function* fetchTeamUsersDataWorker({ requestBody }) {
  try {
    yield put(increaseLoadingCount());
    const { data } = yield userboardApi.getUserboardTeamData(requestBody);
    yield put(saveTeamUsersData(data));
    yield put(decreaseLoadingCount());
  } catch (e) {
    yield put(decreaseLoadingCount());
    yield put(showAlertMessage('error', e.message));
    analytics.trackError('fetch user per team data', e);
  }
}

function* fetchUserBoardFilteredObjectivesWorker({ requestBody }) {
  try {
    yield put(increaseLoadingCount());
    const { data } = yield userboardApi.getUserboardObjectives(requestBody);
    yield put(saveObjectives(data.objective_models));
    yield put(decreaseLoadingCount());
  } catch (e) {
    yield put(decreaseLoadingCount());
    yield put(showAlertMessage('error', e.message));
    analytics.trackError('fetch userboard objectives data', e);
  }
}

function* sendRemindersRequestWorker({ requestBody }) {
  try {
    yield userboardApi.sendReminders(requestBody);
    yield put(showAlertMessage('success', 'Reminder sent successfully'));
  } catch (e) {
    yield put(showAlertMessage('error', e.message));
    analytics.trackError('send reminder from userboard', e);
  }
}

export default function* defaultSaga() {
  yield takeEvery(actions.FETCH_USERBOARD_DATA, fetchUserboardDataWorker);
  yield takeEvery(actions.FETCH_TEAM_USERS_DATA, fetchTeamUsersDataWorker);
  yield takeEvery(
    actions.GET_USERBOARD_FILTERED_OBJECTIVES,
    fetchUserBoardFilteredObjectivesWorker
  );
  yield takeEvery(actions.SEND_REMINDERS_REQUEST, sendRemindersRequestWorker);
}
